import { getRequestContext } from '../context';
import { getUrlDomain } from './getUrlDomain';

const DEV_MERCHANTS_URL = 'https://test.merchants.yandex.ru';
const PRESTABLE_MERCHANTS_URL = 'https://prestable.merchants.yandex.ru';
const PROD_MERCHANTS_URL = 'https://merchants.yandex.ru';

/**
 * Возвращает URL портала Яндекс.Merchants в зависимости от текущего окружения.
 *
 * Для `development` — тестовый стенд, для `prestable` — престейбл, в остальных случаях — продакшн.
 * Если передан `queryDomain`, к URL добавляется путь `/new` с параметром `domain`,
 * содержащим извлечённый и закодированный домен из переданной строки.
 *
 * @param params - Параметры функции.
 * @param params.queryDomain - Строка с доменом (или URL), на основе которого формируется
 *   query-параметр `domain`. Если пустая строка — query-параметр не добавляется.
 * @returns Итоговый URL портала Яндекс.Merchants.
 *
 * @example
 * // Без домена — базовый URL окружения
 * getMerchantsUrl();
 * // => 'https://merchants.yandex.ru'
 *
 * @example
 * // С доменом — добавляется путь /new?domain=...
 * getMerchantsUrl({ queryDomain: 'https://my-shop.ru/catalog' });
 * // => 'https://merchants.yandex.ru/new?domain=my-shop.ru'
 *
 * @kind helper
 */
export const getMerchantsUrl = ({ queryDomain }: { queryDomain?: string } = {}) => {
    const { env } = getRequestContext();
    let url: string;

    if (env === 'development') {
        url = DEV_MERCHANTS_URL;
    } else if (env === 'prestable') {
        url = PRESTABLE_MERCHANTS_URL;
    } else {
        url = PROD_MERCHANTS_URL;
    }

    if (queryDomain) {
        url = `${url}/new?domain=${encodeURIComponent(getUrlDomain(queryDomain))}`;
    }

    return url;
};
